import { render, staticRenderFns } from "./DriverPayoutsTab.vue?vue&type=template&id=2fde993a&"
import script from "./DriverPayoutsTab.vue?vue&type=script&lang=js&"
export * from "./DriverPayoutsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports